import React from 'react';
import styled from 'styled-components';

import { Nav } from '@catalogo/core-nav';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px 0;
  background: #fff;
`;

const Title = styled.h3`
  flex: 1;
  line-height: 1.4;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: ${({ theme }) => theme.textColor};
`;

const Message = styled.p`
  flex: 1;
  font-size: 16px;
  text-align: left;
  margin-top: 1px;
  font-weight: 700;
  color: ${({ theme }) => theme.textColor};
`;

const WrapperLink = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  margin-top: 20px;
`;

const ButtonUI = styled(Nav)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 45px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: normal;
  color: ${({ theme }) => theme.primaryColor};
  border: 2px solid ${({ theme }) => theme.primaryColor};
  text-transform: ${({ theme }) => theme.btnTextTransform};
  font-weight: ${({ theme }) => theme.btnTextWeigth};
  cursor: pointer;

  & :hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export const HasNoQuestions = ({ titleNoQuestions, productId, hasCustomerQuestions, hasOffers }) => (
  <Wrapper>
    <Title>Este produto ainda não tem perguntas.</Title>
    {!hasCustomerQuestions && hasOffers && <Message>{titleNoQuestions}</Message>}
    {hasOffers && (
      <WrapperLink>
        <ButtonUI to={`/perguntar/${productId}`}>Escrever pergunta</ButtonUI>
      </WrapperLink>
    )}
  </Wrapper>
);
